import { MEDICAL_CAM, STETO } from './device-types'
import medicalCameraSrc from '@/assets/img/riesterrcs.jpg'
import stetoscopeSrc from '@/assets/img/thinklabsSteto.jpg'

export type DefaultDevice = {
  name: string
  available: boolean
  customName: string
  iconURL: string
  ptz: boolean
  type: string
}

export const defaultDevices: Array<DefaultDevice> = [
  {
    name: 'Sound Blaster Play! 3',
    available: true,
    customName: 'Sthétoscope',
    iconURL: stetoscopeSrc,
    ptz: false,
    type: STETO,
  },
  {
    name: 'PCP-USB',
    available: true,
    customName: 'Sthétoscope',
    iconURL: stetoscopeSrc,
    ptz: false,
    type: STETO,
  },
  {
    name: 'PNP-USB',
    available: true,
    customName: 'Sthétoscope',
    iconURL: stetoscopeSrc,
    ptz: false,
    type: STETO,
  },
  {
    name: 'DriverCoding UVC Camera',
    available: true,
    customName: 'Camera medicale',
    iconURL: medicalCameraSrc,
    ptz: false,
    type: MEDICAL_CAM,
  },
  {
    name: 'Digital Microscope',
    available: true,
    customName: 'Camera medicale',
    iconURL: medicalCameraSrc,
    ptz: false,
    type: MEDICAL_CAM,
  },
]
